// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1SO0C","type":"styles_type__2S6Zw","choices":"styles_choices__2A9JY"};